module.exports = __webpack_public_path__ + "img/question.f66ace77.svg";